import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field } from 'redux-form';
import { Theme, colors } from 'hui/src/styled/theme';

// TODO: These colors don't exist in HUI.
const lightGrey = '#D9DADA';

//todo make this component/deduplicate??
const QuestionLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
  margin-bottom: 15px;
`;

// parent div for changing the background when selected
const CheckboxStyles = styled.div`
  position: relative;
  input:checked + label {
    background-color: #f5f5f5;
    border-bottom: 1px solid ${lightGrey};
  }
  input:focus {
    outline: none;
  }
`;

// styling for the background
const Label = styled.label`
  cursor: pointer;
  color: ${colors.BLACK};
  text-decoration: none;
  text-align: left;
  font-size: 1em;
  display: block;
  width: 100%;
  padding: 1em 1em 1em 2.5em;
  margin-bottom: 0;
  border-bottom: 1px solid ${lightGrey};
`;

// styling for the checkmark
const Input = styled(Field)`
  width: 1em;
  height: 1em;
  margin-right: 1em;
  margin-bottom: -2px;
  background-color: #fff;
  border: 1px solid ${Theme.greyMedium};
  border-radius: 3px;
  position: absolute;
  top: 17px;
  left: 15px;
  -webkit-appearance: none;
  & :checked {
    background-color: ${Theme.primary};
    border: 1px solid ${Theme.primary};
  }
  & :checked :after {
    content: '';
    position: absolute;
    width: 7px;
    height: 3px;
    background: transparent;
    top: 4px;
    left: 3px;
    border: 1px solid #fff;
    border-top: none;
    border-right: none;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(-45deg);
  }
`;

export default function CheckboxGroup({ options, name, label, stacked }) {
  return (
    <div>
      {label && (
        <QuestionLabel>
          <span>{label}</span>
        </QuestionLabel>
      )}
      {options.map(({ value, label }) => {
        const key = `${name}.${value}`;
        return (
          <CheckboxStyles key={key} stacked={stacked}>
            <Input
              type="checkbox"
              name={key}
              id={key}
              value={`${value}`}
              component={({ input, ...rest }) => {
                return <input name={key} {...input} {...rest} />;
              }}
            />
            <Label key={key} htmlFor={key} stacked={stacked}>
              {label}
            </Label>
          </CheckboxStyles>
        );
      })}
    </div>
  );
}

CheckboxGroup.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.bool,
  stacked: PropTypes.bool
};
